
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mai/[ekey]",
      function () {
        return require("private-next-pages/mai/[ekey].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mai/[ekey]"])
      });
    }
  